module.exports = __webpack_public_path__ + "img/others_22.ba1ad4f6.jpg";